<template>
  <div
    class="tp-login-social mb-10 d-flex flex-wrap align-items-center justify-content-center"
  >
    <div class="tp-login-option-item has-google">
      <a :href="googleUrl">
        <img src="/img/icon/login/google.svg" alt="" />
        <!-- {{ $t("login") }} -->
      </a>
    </div>
    <div class="tp-login-option-item">
      <a :href="facebookUrl">
        <img src="/img/icon/login/facebook.svg" alt="" />
      </a>
    </div>
    <!-- <div class="tp-login-option-item">
      <a href="#">
        <img class="apple" src="/img/icon/login/apple.svg" alt="" />
      </a>
    </div> -->
  </div>
</template>

<script setup lang="ts">
const facebookUrl = computed(() => {
  return useRuntimeConfig().public.FACEBOOK_URL;
});
const googleUrl = computed(() => {
  return useRuntimeConfig().public.GOOGLE_URL;
});
</script>
